// 📁 src/context/DomainContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@api';
import { useAuth } from './AuthContext';

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
 const [organization, setOrganization] = useState(null);
 const [loadingDomain, setLoadingDomain] = useState(true);

 const location = useLocation();
 const pathname = location.pathname;
 const hostname = window.location.hostname.replace(/^www\./, '');

 const { isAuthenticated } = useAuth();

 const isLocalhost = hostname === 'localhost';
 const isSaaSRootDomain = ['sportinghip.com'].includes(hostname);
 const isCustomDomain = !isLocalhost && !isSaaSRootDomain;
 const isSlugRoute = /^\/[a-zA-Z0-9-_]+(\/.*)?$/.test(pathname);
 const isRootPath = pathname === '/';
 const isAuthResolved = isAuthenticated !== null; // assumes it's null/undefined before check
 const isPublicView = isAuthResolved && !isAuthenticated && (isCustomDomain || isSlugRoute || isRootPath);


 const domain = isCustomDomain ? hostname : null;
 const slugFromPath = pathname.split('/').filter(Boolean)[0] || null;
 const slug = !isCustomDomain ? slugFromPath : null;

 
 useEffect(() => {

  if (!isAuthResolved || !isPublicView) {
   setLoadingDomain(false);
   return;
  }
  const fetchOrg = async () => {
   
   try {
    if (isCustomDomain) {
     const res = await api.get(`/api/organizations/domain/${hostname}`);
     setOrganization(res.data.organization);
    } else if (slugFromPath) {
     const res = await api.get(`/api/organizations/slug/${slugFromPath}`);
     setOrganization(res.data.organization);
    } else {
     setOrganization(null);
    }
   } catch (err) {
    console.error("❌ DomainContext Error:", err.response?.data || err.message);
    setOrganization(null);
   } finally {
    setLoadingDomain(false);
   }
  };

  fetchOrg();
 }, [hostname, slugFromPath, isCustomDomain, isPublicView, isAuthenticated ]); // ✅ pathname removed


 return (
  <DomainContext.Provider
   value={{
    organization,
    loadingDomain,
    slug,
    domain,
    hostname,
    isLocalhost,
    isSaaSRootDomain,
    isCustomDomain,
    isPublicView,
   }}
  >
   {children}
  </DomainContext.Provider>
 );
};

export const useDomain = () => useContext(DomainContext);
